import * as classNames from "classnames";
import * as React from "react";
import { Control, Errors } from "react-redux-form";
import * as DTOS from "../../../../FeralScan.dtos";
import { requiredSelect } from "../../../Common/validators";
import { showErrors } from "./ReactReduxFormSettings";
import ValidationMessage from "./ValidationMessage";


export type SelectControlProps = {
    className?: string,
    mandatory: boolean,
    model: string,
    options: DTOS.QuestionOption[],
    readOnly?: boolean,

    //react-redux-form controls these
    touched?: boolean,
    valid?: boolean
};

export type SelectControlActions = {
    onChange?(value: string): void
};

export type SelectControlPropsAndActions = SelectControlProps & SelectControlActions;

class SelectControl extends React.PureComponent<SelectControlPropsAndActions, any> {
    constructor(props: SelectControlPropsAndActions) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(event: React.ChangeEvent<HTMLSelectElement>) {
        if (this.props.onChange)
            this.props.onChange(event.target.value);
    }

    render() {
        return (
            <div className={this.props.className}>
                <Control.select
                    disabled={this.props.readOnly}
                    model={this.props.model}
                    validators={{
                        required: this.props.mandatory ? requiredSelect : () => true
                    }}
                    className={classNames(
                        "form-control",
                        {
                            "form-control-success":
                                this.props.valid && this.props.touched && !this.props.readOnly
                        },
                        {
                            "form-control-danger":
                                !this.props.valid && this.props.touched && !this.props.readOnly
                        }
                    )}
                    onChange={this.onChange.bind(this)}
                >
                    <option value="-1"></option>
                    {this.props.options ?
                        this.props.options.map((option, i) => {
                            return (
                                <option
                                    key={`${this.props.model}.${i}`}
                                    value={option.value}
                                >
                                    {option.label}
                                </option>
                            );
                        }) :
                        undefined}
                </Control.select>

                <Errors
                    className="invalid-feedback d-block"
                    model={this.props.model}
                    messages={{
                        required: "Please select an answer"
                    }}
                    show={showErrors}
                    component={ValidationMessage}
                />
            </div>
        );
    }
}

export default SelectControl;
